module.exports = __webpack_public_path__ + "img/opera.5d0938b8.jpg";